// frontend/src/PaketFormu.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Badge } from 'react-bootstrap';
import api from './api';

// Tanımlı modüller — Gelecekte genişletilebilir
const TANIMLI_MODULLER = [
  { 
    key: 'ogun_modulu', 
    name: 'Öğün Modülü', 
    icon: 'restaurant_menu',
    description: 'Şablonlarım ve Kütüphane sayfalarına erişim',
    sayfalar: ['Şablonlarım', 'Kütüphane']
  },
  { 
    key: 'randevu_modulu', 
    name: 'Randevu Modülü', 
    icon: 'calendar_today',
    description: 'Danışanlar ve Randevularım sayfalarına erişim',
    sayfalar: ['Danışanlar', 'Randevularım']
  },
];

function PaketFormu({ mevcutPaket, onFormSubmit, onIptal }) {
  const [ad, setAd] = useState('');
  const [fiyat, setFiyat] = useState('');
  const [seciliModuller, setSeciliModuller] = useState(new Set());
  const [seciliOzellikIds, setSeciliOzellikIds] = useState(new Set());
  const [tumOzellikler, setTumOzellikler] = useState([]);

  useEffect(() => {
    api.get('/admin/ozellikler').then(res => setTumOzellikler(res.data || []));
  }, []);

  useEffect(() => {
    if (mevcutPaket) {
      setAd(mevcutPaket.ad || '');
      setFiyat(mevcutPaket.fiyat || '');
      setSeciliOzellikIds(new Set(mevcutPaket.ozellikler.map(o => o.id)));
      setSeciliModuller(new Set(mevcutPaket.moduller || []));
    }
  }, [mevcutPaket]);

  const handleModulChange = (modulKey) => {
    const newSet = new Set(seciliModuller);
    if (newSet.has(modulKey)) { newSet.delete(modulKey); }
    else { newSet.add(modulKey); }
    setSeciliModuller(newSet);
  };

  const handleOzellikChange = (ozellikId) => {
    const newSet = new Set(seciliOzellikIds);
    if (newSet.has(ozellikId)) { newSet.delete(ozellikId); } 
    else { newSet.add(ozellikId); }
    setSeciliOzellikIds(newSet);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit({ 
      ad, 
      fiyat: parseFloat(fiyat), 
      moduller: Array.from(seciliModuller),
      ozellik_ids: Array.from(seciliOzellikIds) 
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Paket Adı</Form.Label>
        <Form.Control type="text" value={ad} onChange={(e) => setAd(e.target.value)} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Fiyat (TL)</Form.Label>
        <Form.Control type="number" step="0.01" value={fiyat} onChange={(e) => setFiyat(e.target.value)} required />
      </Form.Group>

      {/* Modül Seçimi */}
      <Form.Group className="mb-3">
        <Form.Label className="fw-bold">Pakete Dahil Modüller</Form.Label>
        <p className="text-muted" style={{ fontSize: '0.85rem' }}>Modüller, kullanıcıların hangi sayfalara erişebileceğini belirler.</p>
        {TANIMLI_MODULLER.map(modul => (
          <div 
            key={modul.key} 
            className={`p-3 mb-2 rounded-3 border ${seciliModuller.has(modul.key) ? 'border-primary' : ''}`}
            style={{ 
              cursor: 'pointer', 
              backgroundColor: seciliModuller.has(modul.key) ? 'rgba(13, 110, 253, 0.08)' : 'transparent',
              transition: 'all 0.2s ease'
            }}
            onClick={() => handleModulChange(modul.key)}
          >
            <Form.Check 
              type="switch"
              id={`modul-${modul.key}`}
              label={
                <div className="ms-2">
                  <div className="fw-bold d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined" style={{ fontSize: '1.1rem' }}>{modul.icon}</span>
                    {modul.name}
                  </div>
                  <div className="text-muted" style={{ fontSize: '0.8rem' }}>{modul.description}</div>
                  <div className="mt-1">
                    {modul.sayfalar.map((s, i) => <Badge key={i} bg="secondary" className="me-1" style={{ fontSize: '0.7rem' }}>{s}</Badge>)}
                  </div>
                </div>
              }
              checked={seciliModuller.has(modul.key)}
              onChange={() => handleModulChange(modul.key)}
            />
          </div>
        ))}
      </Form.Group>

      {/* Ek Özellikler (mevcut sistem) */}
      {tumOzellikler.length > 0 && (
        <Form.Group className="mb-3">
          <Form.Label>Ek Özellikler</Form.Label>
          {tumOzellikler.map(ozellik => (
            <Form.Check 
              type="checkbox"
              key={ozellik.id}
              id={`ozellik-${ozellik.id}`}
              label={ozellik.ad}
              checked={seciliOzellikIds.has(ozellik.id)}
              onChange={() => handleOzellikChange(ozellik.id)}
            />
          ))}
        </Form.Group>
      )}

      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onIptal} className="me-2">İptal</Button>
        <Button variant="primary" type="submit">{mevcutPaket ? 'Güncelle' : 'Oluştur'}</Button>
      </div>
    </Form>
  );
}
export default PaketFormu;